var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMailOutlineIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.333 5.333H6.667c-2.21 0-4 1.791-4 4v13.334c0 2.209 1.79 4 4 4h18.666c2.21 0 4-1.791 4-4V9.333c0-2.209-1.79-4-4-4zM24.44 8L16 14.333 7.56 8h16.88zm.893 16H6.667c-.737 0-1.334-.597-1.334-1.333v-13l9.867 7.4c.23.173.512.266.8.266.288 0 .57-.093.8-.266l9.867-7.4v13c0 .736-.597 1.333-1.334 1.333z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMailOutlineIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mailOutlineIcon.7ea5655d.svg";
export { ForwardRef as ReactComponent };